export const getBtfQueryParameters = (url: string) => {
  const { searchParams } = new URL(url);
  const urlSearchParams = new URLSearchParams(searchParams.toString());

  return urlSearchParams.getAll('btf');
};
